import UnstyledMarkdown from 'markdown-to-jsx';
import { Fragment, useMemo } from 'react';
import Link from '../Link';
import { jsx as _jsx } from "react/jsx-runtime";
const BASE_OVERRIDES = {
  p: ({
    children
  }) => _jsx("p", {
    style: {
      margin: 0,
      whiteSpace: 'pre-line'
    },
    children: children
  }),
  a: props => _jsx(Link, {
    ...props,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      fontSize: 'inherit'
    }
  })
};
const Markdown = ({
  options: optionsProp,
  ...props
}) => {
  const options = useMemo(() => {
    const base = {
      overrides: BASE_OVERRIDES,
      wrapper: Fragment
    };
    return {
      ...base,
      ...optionsProp
    };
  }, [optionsProp]);
  return _jsx(UnstyledMarkdown, {
    options: options,
    ...props
  });
};
export default Markdown;